/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shareshowqr2Inputs */

const en_shareshowqr2 = /** @type {(inputs: Shareshowqr2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show QR code`)
};

const de_shareshowqr2 = /** @type {(inputs: Shareshowqr2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR-Code zeigen`)
};

/**
* | output |
* | --- |
* | "Show QR code" |
*
* @param {Shareshowqr2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const shareshowqr2 = /** @type {((inputs?: Shareshowqr2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shareshowqr2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shareshowqr2(inputs)
	return de_shareshowqr2(inputs)
});
export { shareshowqr2 as "shareShowQr" }